import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

// Components
import { Loader } from '../shared/ui/Loader/Loader';

const ToolPrint = lazy(() => import('../modules/tools/pages/Tool/ToolPrint'));

export const PrintViewRouter = () => {
  return (
    <Routes>
      <Route
        path='tool/:id/print/:pid'
        element={
          <Suspense fallback={<Loader />}>
            <ToolPrint />
          </Suspense>
        }
      />

      <Route path='*' element={<Navigate to='/' />} />
    </Routes>
  );
};
